import { useEffect, useState } from "react";
import { api, fmtError } from "../api";
import { toast } from "sonner";
import { ArrowLeft, UserCog, Save, Loader2 } from "lucide-react";

// Profil: Nutzer legt einen Anzeigenamen (Spitzname/Vorname) fest. Dieser Name
// erscheint im Profil und bei eigenen Aktionen (Annahme, Rückfrage, Rundmail).
export function Profil({ onClose, onSaved }) {
  const token = sessionStorage.getItem("mag_token");
  const [nickname, setNickname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/magauth/profile", { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => { setNickname(data.nickname || ""); setPhone(data.phone || ""); setEmail(data.email || ""); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/magauth/profile", { nickname: nickname.trim(), phone: phone.trim() },
        { headers: { Authorization: `Bearer ${token}` } });
      if (data.nickname) sessionStorage.setItem("mag_nick", data.nickname);
      else sessionStorage.removeItem("mag_nick");
      toast.success("Profil gespeichert.");
      onSaved?.(data);
      onClose();
    } catch (e) {
      toast.error(fmtError(e, "Profil konnte nicht gespeichert werden"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col" style={{ background: "#F8FAFC" }} data-testid="profil">
      <div className="flex items-center gap-3 px-4 py-3" style={{ background: "#fff", borderBottom: "1px solid #E2E8F0" }}>
        <button data-testid="profil-back" onClick={onClose}
          className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ background: "#F1F5F9", border: "none", cursor: "pointer" }}><ArrowLeft size={18} /></button>
        <span className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "#FFF7ED" }}>
          <UserCog size={18} color="#F97316" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="font-extrabold text-base truncate">Mein Name</div>
          <div className="text-xs truncate" style={{ color: "#64748B" }}>Anzeigename / Spitzname festlegen</div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="container-wd py-6" style={{ maxWidth: 560 }}>
          <div className="card-wd p-4 sm:p-5">
            {loading ? (
              <div className="flex items-center gap-2 text-sm" style={{ color: "#64748B" }}>
                <Loader2 size={16} className="animate-spin" /> Profil wird geladen …
              </div>
            ) : (
              <>
                <label className="text-xs font-bold" style={{ color: "#475569" }}>Anzeigename / Spitzname</label>
                <input data-testid="profil-nickname" className="input-wd mt-1" maxLength={40}
                  placeholder="z. B. Thomas oder Hausmeister Nord"
                  value={nickname} onChange={(e) => setNickname(e.target.value)} />
                <p className="text-xs mt-2 mb-0" style={{ color: "#94A3B8" }}>
                  Dieser Name erscheint in deinem Profil und bei deinen Aktionen (Annahme, Rückfrage, Rundmail).
                  Leer lassen, um wieder den Standardnamen zu verwenden.
                </p>

                <div className="mt-4">
                  <label className="text-xs font-bold" style={{ color: "#475569" }}>Telefonnummer</label>
                  <input data-testid="profil-phone" className="input-wd mt-1" maxLength={40} type="tel"
                    placeholder="z. B. +49 170 1234567"
                    value={phone} onChange={(e) => setPhone(e.target.value)} />
                  <p className="text-xs mt-2 mb-0" style={{ color: "#94A3B8" }}>
                    Manager hinterlegen hier ihre Nummer – Hausmeister können sie dann über die Aktion „Anrufen" direkt anrufen.
                  </p>
                </div>

                <div className="mt-4">
                  <label className="text-xs font-bold" style={{ color: "#475569" }}>Anmeldung</label>
                  <input data-testid="profil-email" className="input-wd mt-1" value={email} readOnly disabled
                    style={{ background: "#F1F5F9", color: "#64748B" }} />
                </div>

                <div className="flex items-center justify-end mt-5">
                  <button data-testid="profil-save" className="btn-primary" disabled={busy} onClick={save} style={{ height: 44 }}>
                    {busy ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Speichern
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
